@import "src/styles/common/_colors.scss";

.trsReportWrapper {
  gap: 1rem;
  display: flex;
  padding: 0.625rem 0;
  height: 100%;
}

.trsSectionsWrapper {
  height: 100%;
  flex: 1;

  .sectionPanel {
    height: calc(100% - 20px);

    .sectionList {
      background: $gray;
      height: 98%;
      overflow-y: auto;
      border: 1px solid $black;
      padding: 1rem;
    }
  }

  .emptyMessage {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 1rem;
  }
}

